<template>
  <div class='coursework-viewer__slide'>
    <div class='coursework-viewer__no-preview'>
      <div class='coursework-viewer__no-preview_icon'>
      <span class='kf-stack kf-stack--circle'>
        <i class='kf kf-circle-outline'></i>
        <i class='kf kf-project'></i>
      </span>
      </div>
      <div class='coursework-viewer__no-preview_title'>This {{ subject.toLowerCase() }} is empty</div>
      <div class='coursework-viewer__no-preview_description'>There is no media available to preview.</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      subject: String
    },
    mounted() {
      this.$emit('ready')
    }
  }
</script>